import axios from "axios";
import store from '../store';


export default {

    hash : null,
    url  : process.env.VUE_APP_API_URL,

    reloadhash(){
        this.hash = '?hash='+store.state.hash
    },

    getDashboardDetails(){
        this.reloadhash()
        return axios.get(this.url +'dash-information'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;});
    },
    getBranch(){
        this.reloadhash()
        return axios.get(this.url +'branch'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;});
    },
    getProvince(){
        return axios.get("https://psgc.gitlab.io/api/provinces")
            .then(response=> response.data)
            .catch(error => {
                throw error;});
    },
    getEmployeeInfo(){
        this.reloadhash()
        return axios.get(this.url +'get-information'+ this.hash
        )
            .then(response => response.data)
            .catch(error => {
                throw error;});
    },

    getEmployeeDetailsWithPosition(){
        this.reloadhash()
        return axios.get(this.url +'employee-details'+ this.hash
        )
            .then(response => response.data)
            .catch(error => {
                throw error;});
    },

    getImage(feed_key){
        this.reloadhash()
        return axios.get(this.url +'get-image'+ this.hash,{
            params:{
                feed_key: feed_key
            }
     
        }).then(response => response.data).catch(error => {throw error;});
    },
    
    login(user, pass) {
        return axios.post( this.url + 'login', { username: user, password: pass })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    getDepartment(){
        this.reloadhash()
        return axios.get(this.url + 'department'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    addDepartment(division_code,department,abbr){
        this.reloadhash()
        return axios.post(this.url +  'add-department'+ this.hash,
            { 
                department    : department,
                abbr          : abbr,
                division_code : division_code 
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    editDepartment(division_code,department,abbr,id){
        this.reloadhash()
        return axios.patch(this.url + 'edit-department/'+ id + this.hash,
            { 
                department    : department,
                abbr          : abbr,
                division_code : division_code
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getDepartmentbyDiv(div_code){
        this.reloadhash()
        return axios.get(this.url + 'department/' + div_code + this.hash);
    },
    //DEPARTMENT END

    //SECTION START
    getSection(){
        this.reloadhash()
        return axios.get(this.url + 'section'+ this.hash);
    },
    addSection(division_code,department_code,section,abbr){
        this.reloadhash()
        return axios.post( this.url + 'add-section'+ this.hash,
            { 
                division_code       : division_code,
                department_code     : department_code,
                section             : section,
                abbr                : abbr
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    editSection(id,division_code,department_code,section,abbr){
        this.reloadhash()
        return axios.patch(this.url + 'edit-section/'+ id + this.hash,
            { 
                division_code       : division_code,
                department_code     : department_code,
                section             : section,
                abbr                : abbr
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //SECTION END

    //POSITION START
    getPosition(){
        this.reloadhash()
        return axios.get(this.url + 'position'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getPositionkey(){
        this.reloadhash()
        return axios.get(this.url + 'get-positionkey'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    addPosition(division_code,department_code,section_code,rank,position,office){
        this.reloadhash()
        return axios.post(this.url + 'add-position'+ this.hash,
            { 
                division_code       : division_code,
                department_code     : department_code,
                section_code        : section_code,
                rank                : rank,
                position            : position,
                office              : office,
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getPositionbyID($id){
        this.reloadhash()
        return axios.get(this.url + 'section/'+ $id + this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getSectionbyDivCode($id){
        this.reloadhash()
        return axios.get(this.url +  'section-div/'+ $id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    editPosition(id,division_code,department_code,section_code,rank,position,status,office){
        this.reloadhash()
        return axios.patch(this.url +  'edit-position/'+ id+ this.hash,
            { 
                division_code       : division_code,
                department_code     : department_code,
                section_code        : section_code,
                rank                : rank,
                position            : position,
                status              : status,
                office              : office
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //POSITION END

    //POLICIES PROCEDURES START
    addPoliciesProcedures(title, description,department,source){
        this.reloadhash()
        var form = new FormData();

        form.append("title"       , title);
        form.append("description" , description);
        form.append("department"  , department);
        form.append("source"      , source);

        return axios.post(this.url +  'add-policies-procedures', form)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
            
    },

    
    getPoliciesProcedures(){
        this.reloadhash()
        return axios.get(this.url +  'policies-procedures'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getPoliciesProceduresbyID($id){
        this.reloadhash()
        return axios.get(this.url + 'policies-procedures/'+ $id+ this.hash);
    },
    deletePoliciesProceduresbyID($id){
        this.reloadhash()
        return axios.delete(this.url +  'delete-policiesprocedures/'+ $id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END POLICIES PROCEDURES

    //START EMPLOYEE PROFILE
    searchEmployee(name){
        this.reloadhash()
        return axios.get(this.url +  'search-employee/'+ name+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
        
    },
    getEmployeeName(){
        this.reloadhash()
        return axios.get(this.url + 'employee-infomation'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getEmployeeNameByid($id){
        this.reloadhash()
        return axios.get(this.url + 'employee-infomation/'+ $id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    UpdateEmployeeNameByid($id,fname,mname,lname,bdate,bplace,gender,civil,nationality,religion,sss,philhealth,pagibig,tin,landline,email,emergencyContactInformation,relationship,emergengcyContactNumber,branch_code,cp_no,sex){
        this.reloadhash()
        return axios.patch(this.url + 'update-employee-information/'+ $id+ this.hash,
        { 
            fname                       : fname,
            mname                       : mname,
            lname                       : lname,
            bdate                       : bdate,
            bplace                      : bplace,
            gender                      : gender,
            civil                       : civil,
            nationality                 : nationality,
            religion                    : religion,
            sss                         : sss,
            philhealth                  : philhealth,
            pagibig                     : pagibig,
            tin                         : tin,
            landline                    : landline,
            email                       : email,
            emergencyContactInformation : emergencyContactInformation,
            relationship                : relationship,
            emergengcyContactNumber     : emergengcyContactNumber,
            branch_code                 : branch_code,
            cp_no                       : cp_no,
            sex                         : sex
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END EMPLOYEE PROFILE

    //START JOB DESCRIPTION
    getJobDescription(search){
        this.reloadhash()
        return axios.get(this.url + 'jobdescription'+ this.hash,{
            params:{
                search:search
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    updateJobDescription(id,remarks,file){
        this.reloadhash()
        var form = new FormData();

            form.append("remarks" , remarks);
            form.append("file"    , file   );
              
        return axios.post(this.url + 'edit-jobdescription/'+ id+ this.hash, form)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getJobDescriptionbyID(id){
        this.reloadhash()
        return axios.get(this.url +  'get-jobdescription-id/'+ id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END JOB DESCRIPTION

    //START EMPLOYEE 201
    addEmployee201(title,remarks,source,employee_key){
        this.reloadhash()
        var form = new FormData();
                form.append("title"         , title);
                form.append("remarks"       , remarks);
                form.append("source"        , source);
                form.append("employee_key"  , employee_key);
            
        return axios.post(this.url + 'add-employee201'+ this.hash, form)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    get201Files(search){
        this.reloadhash()
        return axios.get(this.url + 'employee201'+ this.hash,{
            params:{
                search:search
            }
       
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

     get201FilesbyID(id){
        this.reloadhash()
        return axios.get(this.url + '201file/'+ id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    delete201FilesbyID(id){
        this.reloadhash()
        return axios.delete(this.url + 'delete-201file/'+ id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END EMPLOYEE 201
    
    //START NEWSLETTER
    addNewsletter(title,file){
        this.reloadhash()
        var form = new FormData();
                form.append("title"        , title);
                form.append("source"       , file);
            
        return axios.post(this.url + 'add-newsletter'+ this.hash , form )
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getNewsletter(){
        this.reloadhash()
        return axios.get(this.url + 'newsletter'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    deleteNewsletter(id){
        this.reloadhash()
        return axios.delete(this.url + 'newsletter/'+ id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getNewsletterbyID(id){
        this.reloadhash()
        return axios.get(this.url + 'get-newsletter/'+ id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END NEWSLETTER

    //START ANNOUNCEMENT

    addAnnouncement(title,captions,file){
        this.reloadhash()
        var form = new FormData();
            form.append("title"       , title);
            form.append("captions"    , captions);
            form.append("source"      , file);
        return axios.post(this.url + 'add-announcement'+ this.hash, form)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    editAnnouncement(feed_key,title,captions,file){
        this.reloadhash()
        var form = new FormData();
        form.append("feed_key", feed_key);
        form.append("title", title);
        form.append("captions", captions);
        form.append("source", file);

        return axios.post(this.url + 'edit-announcement'+ this.hash,form)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getAnnouncement(){
        this.reloadhash()
        return axios.get(this.url + 'announcement'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    deleteAnnouncement(id){
        this.reloadhash()
        return axios.delete(this.url + 'announcement/'+ id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    //END ANNOUNCEMENT

    //START ADDRESS

    getAddress(id,type){
        this.reloadhash()
        return axios.get(this.url + 'get-address/'+ id + '/'+ type+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    updateAddress(id,type,add1,province,city,brgy,zip){
        this.reloadhash()
        return axios.post(this.url + 'home-address/'+ id + '/'+ type + this.hash,{
            add1        :add1,
            province    :province,
            city        :city,
            brgy        :brgy,
            zip         :zip,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    //END ADDRESS

    //START SPOUSE INFORMATION

    getSpouseInformation(empid){
        this.reloadhash()
        return axios.get(this.url + 'spouseinformation/'+ empid + this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    updateSpouseInformation(employee_key,fname,lname,mname,birthplace,birthdate,marriage_date,marriage_place,address,contact_no,occupation,employer_name,employer_contact,employer_address){
        this.reloadhash()
        return axios.post(this.url + 'spouseinformation'+ this.hash,
        {
            employee_key        :    employee_key,
            fname               :    fname,
            lname               :    lname,
            mname               :    mname,
            birthplace          :    birthplace,
            birthdate           :    birthdate,
            marriage_date       :    marriage_date,
            marriage_place      :    marriage_place,
            address             :    address,
            contact_no          :    contact_no,
            occupation          :    occupation,
            employer_name       :    employer_name,
            employer_contact    :    employer_contact,
            employer_address    :    employer_address,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    //END SPOUSE INFORMATION

    //START EMPLOYMENT
    updateEmploymentInformation(employee_key,salarygrade,employee_status,hired_date,position_key,division_code,department_code,section_code){
        this.reloadhash()
        return axios.post(this.url + 'employment-info'+ this.hash, 
        {
            employee_key        :    employee_key,
            salarygrade         :    salarygrade,
            employee_status     :    employee_status,
            hired_date          :    hired_date,
            position_key        :    position_key,
            division_code       :    division_code,
            department_code     :    department_code,
            section_code        :    section_code,    
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    //END EMPLOYMENT


    //START PARENTS INFORMATION

    updateParentsInformation(employee_key,type,fname,mname,lname,contact_no,birthdate){
        this.reloadhash()
        return axios.post(this.url + 'parents-information'+ this.hash, 
        {
            employee_key    :    employee_key,
            type            :    type,
            fname           :    fname,
            mname           :    mname,
            lname           :    lname,
            contact_no      :    contact_no,
            birthdate       :    birthdate, 
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    //END PARENTS INFORMATION



    //START FILE MAINTENACE

    getForms(){
        this.reloadhash()
        return axios.get(this.url + 'getforms'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    addForms(form_description,form_status){
        this.reloadhash()
        return axios.post(this.url + 'forms'+ this.hash,
        {
            form_description    :form_description,
            form_status         :form_status,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    deleteForm($id){
        this.reloadhash()
        return axios.delete(this.url + 'delete-forms/'+ $id+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    updateForms(form_key,form_name,form_status){
        this.reloadhash()
        return axios.patch(this.url + 'update-form'+ this.hash,
        {
            form_key    : form_key,
            form_name   : form_name,
            form_status : form_status
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END FILE MAINTENANCE


    //REQUEST FORM

    getRequestForms(){
        this.reloadhash()
        return axios.get(this.url + 'get-requestforms'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getRequestFormsbyid(request_key){
        this.reloadhash()
        return axios.get(this.url + 'get-requestformsbyreqkey/'+ request_key+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getApprovedRequestForms(){
        this.reloadhash()
        return axios.get(this.url + 'get-approvedrequestforms'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    approvedRequestForms(request_key,process_emp_key){
        this.reloadhash()
        return axios.patch(this.url + 'approve-requestforms'+ this.hash,
        {
            request_key :request_key,
            process_emp_key :process_emp_key
        }
        )
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //REQUEST FORM


    verifyAccount(session){
        this.reloadhash()
        return axios.get(this.url + 'verify'+ this.hash,{
            params:{
                session:session
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },

    //START SIGNATORY

    getSignatory(div_key,dep_key,sec_key,rank,signatoryType){
        this.reloadhash()
        return axios.get(this.url + 'getassignsignatory'+ this.hash,
        {
            params:{
                rank          : rank,
                div_key       : div_key,
                dep_key       : dep_key,
                sec_key       : sec_key,
                signatoryType : signatoryType

            }
             
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getPsoSignatory(br_code,rank,signatoryType){
        this.reloadhash()
        return axios.get(this.url + 'pso-signatory'+ this.hash,
        {
            params:{
                rank          : rank,
                br_code       : br_code,
                signatoryType : signatoryType
            } 
        })
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
    },

    addPsoSignatory(br_code,rank,employee_key,signatory_type,signatoryType){
        this.reloadhash()
        return axios.post(this.url + 'pso-signatory'+ this.hash,
            {
                br_code         : br_code,
                rank            : rank,
                employee_key    : employee_key,
                signatory_type  : signatory_type,    //RECCOMMENDATION OR APPROVAL
                signatoryType   : signatoryType     // LEAVE CONDSIDE TRAINING
            }).then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    addSignatory(div_key,dep_key,sec_key,rank,employee_key,signatory_type,signatoryType){
        this.reloadhash()
        return axios.post(this.url + 'assignsignatory'+ this.hash,
        {
            rank            : rank,
            div_key         : div_key,
            dep_key         : dep_key,
            sec_key         : sec_key, 
            employee_key    : employee_key,
            signatory_type  : signatory_type,    //RECCOMMENDATION OR APPROVAL
            signatoryType   : signatoryType     // LEAVE CONDSIDE TRAINING
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    // addPsoSignatory(br_code,rank,employee_key,signatory_type,signatoryType){
    //     this.reloadhash()
    //     return axios.post(this.url + 'assignsignatory'+ this.hash,
    //     {
    //         rank            : rank,
    //         br_code         : br_code,
    //         employee_key    : employee_key,
    //         signatory_type  : signatory_type,    //RECCOMMENDATION OR APPROVAL
    //         signatoryType   : signatoryType     // LEAVE CONDSIDE TRAINING
    //     })s
    //         .then(response => response.data)
    //         .catch(error => {
    //             throw error;
    //         });
    // },

    getTrainingSignatory(){
        this.reloadhash()
        return axios.get(this.url + 'trn-signatory'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    addtrainingSignatory(employee_key,signatory_type){
        this.reloadhash()
        return axios.post(this.url + 'training-signatory'+ this.hash,
        {
        
            employee_key    : employee_key,
            signatory_type  : signatory_type, 
          
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    deleteSignatory(id){
        this.reloadhash()
        return axios.delete(this.url +  'deletesignatory'+ this.hash,
        {
            params:{
                id : id,
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //END SIGNATORY

    //START ADMIN ACC
    addAdminAccount(username,password,employee,accAccess,ancAccess,optAccess,signAccess,reqAccess,empAccess,payAccess,servAccess,poliAccess){
        this.reloadhash()
        return axios.post(this.url + 'admin-account'+ this.hash,{
            username:   username,
            password:   password,
            employee:   employee,
            accAccess:  accAccess,
            optAccess:  optAccess,
            ancAccess:  ancAccess,
            signAccess: signAccess,
            reqAccess:  reqAccess,
            empAccess:  empAccess,
            payAccess:  payAccess,
            servAccess: servAccess,
            poliAccess: poliAccess,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getAdminAccount(){
        this.reloadhash()
        return axios.get(this.url + 'getadminaccount'+ this.hash,)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getSuperAdmin(){
        this.reloadhash()
        return axios.get(this.url + 'super-admin' + this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    deleteAdminAccount(id){
        return axios.delete(this.url + 'admin-account/'+ id + this.hash,)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    editAdminAccount(id,username,password,employee,accAccess,ancAccess,optAccess,signAccess,reqAccess,empAccess,payAccess,servAccess,poliAccess){
        this.reloadhash()
        return axios.post(this.url + 'edit-admin/'+ id + this.hash,
        {
                username:   username,
                password:   password,
                employee:   employee,
                accAccess:  accAccess,
                optAccess:  optAccess,
                ancAccess:  ancAccess,
                signAccess: signAccess,
                reqAccess:  reqAccess,
                empAccess:  empAccess,
                payAccess:  payAccess,
                servAccess: servAccess,
                poliAccess: poliAccess,
            
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    //END ADMIN ACC

    //EDIT EMPLOYEE ACC
    editEmployeeAccount(id,username,password){
        return axios.post(this.url + 'employeecccount' + this.hash,
        {
          
            employee_key    :   id,
            username        :   username,
            password        :   password
            
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    //END EDIT EMPLOYEE ACC



    //START CONSIDERATION
    getConsideration(name){
        this.reloadhash()
        return axios.get(this.url + 'considerationrequest'+ this.hash,
        {
            params:{
                name:name
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getnotedConsideration(){
        this.reloadhash()
        return axios.get(this.url + 'notedconsiderationrequest'+ this.hash,)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    notedbyConsideration(consi_no,employee_key){
        this.reloadhash()
        return axios.post(this.url + 'notedconsideration'+ this.hash,{
            consi_no:consi_no,
            employee_key:employee_key
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    
    //END CONSIDERATION

    //START LEAVE REAQUEST
    
    getAllRequestLeave(name){
        this.reloadhash()
        return axios.get(this.url + 'getrequestLeave'+ this.hash,{
            params:{
                name : name
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getAllNotedRequestLeave(){
        this.reloadhash()
        return axios.get(this.url + 'notedleave'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    notedByLeave(employee_key,leave_key){
        this.reloadhash()
        return axios.post(this.url + 'notedbyleave'+ this.hash,{
            leave_key:leave_key,
            employee_key:employee_key
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });
    },
    leaveCoveredDate(leave_key){
        this.reloadhash()
        return axios.get(this.url + 'leave_date'+ this.hash,
        { params:{
            leave_key:leave_key,
        }
           
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });
    },

    //END


    //START LEAVE FORM

    //GET ALL LEAVE CREDIT PER EMPLOYEE
    getAllLeaveCredit(search){
        this.reloadhash()
        return axios.get(this.url + 'getleavecredit'+ this.hash,{
            params:{
                search:search
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });
    },

    //GET ALL LEAVE RECORD OF EMPLOYEE
    getLeaveRecord(leaverecord_no){
        this.reloadhash()
        return axios.get(this.url + 'get-leave-record'+ this.hash,
        {
            params:{
                leaverecord_no:leaverecord_no
            }
        },
        )
            .then(response => response.data)
            .catch(error => {
                throw error;
        });
    },

    //ADD LEAVE RECORD START
    addLeaveRecord(employee_key,calendar_year,credit_days,credit_hour){
        this.reloadhash()
        return axios.post(this.url + 'leave-credit'+ this.hash,
        {
            employee_key:employee_key,
            calendar_year:calendar_year,
            credit_days: credit_days,
            credit_hour: credit_hour,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    addLeave(from_date,to_date,particular,days,undertime,late,remarks,leaverecord_no){
        this.reloadhash()
        return axios.post(this.url +  'leave-record'+ this.hash,
        {
            from_date       :   from_date,
            to_date         :   to_date,
            particular      :   particular,
            days            :   days,
            undertime       :   undertime,
            late            :   late,
            remarks         :   remarks,
            leaverecord_no  :   leaverecord_no,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },


    //END LEAVE RECORD 




    //END LEAVE FORM


    //GET DISPLAY PICTURE OF SPECIFIC EMPLOYEE
    getDisplayPicture(employee_key){
        this.reloadhash()
        return axios.get(this.url + 'display-picture'+ this.hash,
        { params:{
            employee_key:employee_key,
        }
        
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },

    //MESSAGE MODULE
    getInbox(employee_key){
        this.reloadhash()
        return axios.get(this.url + 'inbox'+ this.hash,         
        { 
            params:{
            employee_key:employee_key,
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getMessage(message_key){
        this.reloadhash()
        return axios.get(this.url + 'getmessage'+ this.hash,         
        { 
            params:{
                message_key:message_key,
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    sendMessage(employee_key,to_employee_key,message){
        return axios.post(this.url + 'message'+ this.hash,
        {
            employee_key       :   employee_key,
            to_employee_key    :   to_employee_key,
            message            :   message,
        
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },



    //END MESSAGE MODULE
    employeeWithPosition(){
        this.reloadhash()
        return axios.get(this.url + 'employee-position'+ this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //GET LEAVE SGINATORY
    leaveSignatory(leave_key){
        this.reloadhash()
        return axios.get(this.url + 'leave_signatory'+ this.hash,
        {
            params:{
                 leave_key : leave_key
            }
           
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    //GET CONSI SIGNATORY
    consiSignatory(consideration_key){
        this.reloadhash()
        return axios.get(this.url + 'consi_signatory'+ this.hash,
        {
            params:{
                consideration_key  :    consideration_key,
            }
           
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    getTrainingRequest(name){
        this.reloadhash()
        return axios.get(this.url + 'get-request-training'+ this.hash,{
            params:{
                name:name
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });
    },     

    getTrainingIndorsement(type){
        this.reloadhash()
        return axios.get(this.url + 'training-indorsement/'+ type + this.hash)
            .then(response => response.data)
            .catch(error => {
                throw error;
        });
    },




    //DELETE POSITION AND JOB DESCRIPTION
    deletePosition(position_key){
        this.reloadhash()
        return axios.delete(this.url +  'delete-position'+ this.hash,
        {
            params:{
                position_key  :    position_key,
            } 
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    }, 

    //EDIT LEAVE RECORD HEADER
    editLeaveRecord(leaverecord_key,employee_key,calendar_year,credit_days,credit_hour) {
        this.reloadhash()
        return axios.post(this.url + 'edit-leave-record'+ this.hash,
        {
           
                leaverecord_key     :    leaverecord_key,
                employee_key        :    employee_key,
                calendar_year       :    calendar_year,
                credit_days         :    credit_days,
                credit_hour         :    credit_hour,
          
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    deleteLeaveRecord(id) {
        this.reloadhash()
        return axios.delete(this.url + 'delete-leave-record'+ this.hash,
        {
            params:{
                id     :    id
            }
           
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },
    addNewEmployee(fname,mname,lname){
        this.reloadhash()
        return axios.post(this.url + 'new-employee'+ this.hash,
        {
            fname    :    fname,
            mname    :    mname,
            lname    :    lname,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });

    },

    //FORGOT PASSWORD USERNAME VERIFY
    verifyUsername(username){

        return axios.get(this.url + 'forgot-password',
        {   params:{
            username : username
            }
          
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    sendOTP(email,otp,username){
        
        return axios.post(this.url + 'email-otp',
        {
            username    :   username,
            email       :   email,
            otp         :   otp,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
    forgotPasswordChange(username,password){
        return axios.post(this.url + 'forgot-password',
        {
            username : username,
            password : password,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });  
    },

    trainingSignatory(training_key){
        this.reloadhash()
        return axios.get(this.url + 'training-signatory'+ this.hash,
        {   
            params:{
                training_key  :    training_key
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });  
    },
    trainingApproval(training_key,employee_key,type){
        this.reloadhash()
        return axios.post(this.url + 'training-approval'+ this.hash,
        {   
        
                training_key  :   training_key,
                employee_key  :   employee_key,
                type          :   type
           
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });  
    },
    //Add dependent
    addDependent(fname,lname,mname,aname,birthdate,contact_no,relation,employee_key){
        this.reloadhash()
        return axios.post(this.url + 'add-dependent'+ this.hash,
        {   
            employee_key    :   employee_key,
            fname           :   fname,
            lname           :   lname,
            mname           :   mname,
            aname           :   aname,
            birthdate       :   birthdate,
            contact_no      :   contact_no,
            relation        :   relation,
        })
            .then(response => response.data)
            .catch(error => {
                throw error;
        });  
    },

    deleteDependent(id){
        this.reloadhash()
        return axios.delete(this.url + 'delete-dependent'+ this.hash,{
            params:{
                id : id
            }
        
        })
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
    },
    changePassword(employee_key,currentPassword,password){
        this.reloadhash()
        return axios.post(this.url + 'change-password' + this.hash,{
       
                employee_key     :    employee_key,
                currentPassword  :    currentPassword,
                password         :    password,
         
        })
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
    },
    getPayroll(name){
        this.reloadhash()
        return axios.get(this.url + 'payroll'  + this.hash,
        {
            params:{
                name : name
            }
        })
        .then(response => response.data)
        .catch(error => {
        throw error;
        });
    },
    async getPayssss(employee_key,pay_month,pay_year){
        this.reloadhash()
        return await axios.get(this.url + 'pay-slip' + this.hash,
        {
            params:{
                employee_key    :   employee_key,
                pay_month       :   pay_month,
                pay_year        :   pay_year,
            }
        })
        .then(response => response.data)
        .catch(error => {
            alert(error);
        });
    },
    getPayDesc(){
        this.reloadhash()
        return axios.get(this.url + 'pay-desc' + this.hash)
        .then(response => response.data)
        .catch(error => {
        alert(error);
        });
    },

    getPdfpayroll(name,word,pay15,pay30,netpay,earn,ded,info,paydesc,deddesc){
        this.reloadhash()
        return axios.get(this.url + 'view-payroll' + this.hash,{
            responseType: 'arraybuffer',
            params:{
                name:name,
                word:word,
                pay15:pay15,
                pay30:pay30,
                netpay:netpay,
                earn:earn,
                ded:ded,
                info:info,
                paydesc:paydesc,
                deddesc:deddesc,
            }

        }
       ).then(response => {
        // Create a blob object from the binary data received
        const blob = new Blob([response], { type: 'application/pdf' });
        // Create a URL for the blob object
        const url = window.URL.createObjectURL(blob);

        // Open the PDF in a new tab
        window.open(url, '_blank');
      }).catch(error => {
        // Handle errors
        console.error('Error fetching payroll:', error);
      });
    },

    verifyModule(employee_key){
        this.reloadhash()
        return axios.get(this.url + 'verify-module' + this.hash,{
            params:{
                employee_key:employee_key
            }
       
        })
        .then(response => response.data)
        .catch(error => {
        throw error;
        });
    },
    verifyTraining(employee_key){
        this.reloadhash()
        return axios.get(this.url + 'verify-training' + this.hash,{
                employee_key:employee_key
        })
        .then(response => response.data)
        .catch(error => {
        throw error;
        });
    },

    editLeave(id,fromdate,todate,particular,days,undertime,late,remarks){
        this.reloadhash()
        return axios.post(this.url + 'edit-leave' + this.hash,{
            id:id,
            fromdate:fromdate,
            todate:todate,
            particular:particular,
            days:days,
            undertime:undertime,
            late:late,
            remarks:remarks,
       
        })
        .then(response => response.data)
        .catch(error => {
        throw error;
        });
    }

}